export default __webpack_public_path__ + "static/media/brasao.08deeb32.png";